import TrainSessionSteady from "./TrainSessionSteady";

/** Morning yoga & breathing's listing before Start, for either programme (ADR-067). */
export default function TrainYoga() {
  return <TrainSessionSteady extra="YB" />;
}
